import React, { Fragment, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { useSystemActions } from "@_recoil/_actions";
import { systemAtom } from "@_recoil/_state";
import API from "@unisearch/helpers/api";
import Link from "next/link";
import { useRouter } from "next/router";
import styles from "./uni_links.module.scss";
import { countries } from "country-data";
export const UniLinks = (props) => {
  const router = useRouter();
  const { asPath, query } = router;
  const systemActions = useSystemActions();
  const systemInfo = useRecoilValue(systemAtom);

  const [menuStatus, setMenuStatus] = useState({});

  let coursesLevelPageLink;

  const overviewPageLink = `/study/${query.country_name}/university/${query.university_name}`;
  const admissionFaqPageLink = `/study/${query.country_name}/university/${query.university_name}/admission-faq`;
  const rankingPageLink = `/study/${query.country_name}/university/${query.university_name}/ranking`;

  const coursesPageLink = `/study/${query.country_name}/university/${query.university_name}/courses`;
  query.course_level
    ? (coursesLevelPageLink = `/study/${query.country_name}/university/${query.university_name}/courses/${query.course_level}`)
    : "";
  const searchCoursePageLink = `/study/${query.country_name}/university/${query.university_name}/search-courses`;

  const scholarshipsPageLink = `/study/${query.country_name}/university/${query.university_name}/scholarships`;
  const scholarshipDetailsPageLink = `/study/${query.country_name}/university/${query.university_name}/scholarships/${query.scholarship_slug}`;

  const blogPageLink = `/study/${query.country_name}/university/${query.university_name}/blog`;
  const staffPageLink = `/study/${query.country_name}/university/${query.university_name}/staff`;
  const eventFairPageLink = `/study/${query.country_name}/university/${query.university_name}/event-fair`;
  const galleryPageLink = `/study/${query.country_name}/university/${query.university_name}/gallery`;
  const reviewPageLink = `/study/${query.country_name}/university/${query.university_name}/reviews`;
  const contactPageLink = `/study/${query.country_name}/university/${query.university_name}/contact`;

  const getIpInof = async () => {
    let default_country = localStorage.getItem("default_country");

    if (default_country && default_country != "") {
      //set visitor default courrencies
      if (
        (!systemInfo?.currency || systemInfo?.currency == "") &&
        countries[default_country.toUpperCase()]?.currencies[0] &&
        countries[default_country.toUpperCase()]?.currencies[0] != ""
      ) {
        systemActions.setSystemCurrency(
          countries[default_country.toUpperCase()]?.currencies[0]
        );
      }

      //set visitor countries
      if (
        (!systemInfo?.visitor_country ||
          Object.keys(systemInfo?.visitor_country).length === 0) &&
        countries[default_country.toUpperCase()]?.name &&
        countries[default_country.toUpperCase()]?.name != ""
      ) {
        systemActions.setVisitorCountry(
          countries[default_country.toUpperCase()]
        );
      }
    }
  };

  //get IP Info
  useEffect(() => {
    getIpInof();
  }, []);

  useEffect(() => {
    async function getMenuStatius() {
      // You can await here
      await API.get(
        `/public/university/menu-status/${query.university_name}`
      ).then((resp) => {
        if (!resp.error && resp.data) {
          setMenuStatus(resp.data);
        } else {
          setMenuStatus({});
        }
      });
    }
    getMenuStatius();
  }, [query.university_name]);

  // set system currency
  const setSystemCurrency = (e) => {
    systemActions.setSystemCurrency(e.target.value);
  };

  return (
    <section className={styles.section_links}>
      <div className={styles.links_wrapper}>
        <div className="container">
          <div className={styles.links_container}>
            <ul className={styles.link_lists}>
              <li>
                <Link legacyBehavior href={overviewPageLink}>
                  <a
                    className={`${styles.link_list_item} ${
                      asPath === overviewPageLink ? `${styles.active}` : ""
                    }`}
                  >
                    Overview
                  </a>
                </Link>
              </li>

              {menuStatus?.faq && menuStatus?.faq === 1 ? (
                <li>
                  <Link legacyBehavior href={`${admissionFaqPageLink}`}>
                    <a
                      className={`${styles.link_list_item} ${
                        asPath === admissionFaqPageLink
                          ? `${styles.active}`
                          : ""
                      }`}
                    >
                      Admission FAQ
                    </a>
                  </Link>
                </li>
              ) : (
                ""
              )}

              {menuStatus?.ranking && menuStatus?.ranking == 1 ? (
                <li>
                  <Link legacyBehavior href={`${rankingPageLink}`}>
                    <a
                      className={`${styles.link_list_item} ${
                        asPath === rankingPageLink ? `${styles.active}` : ""
                      }`}
                    >
                      Rankings
                    </a>
                  </Link>
                </li>
              ) : (
                ""
              )}

              {menuStatus?.course && menuStatus?.course == 1 ? (
                <li>
                  <Link legacyBehavior href={`${coursesPageLink}`}>
                    <a
                      className={`${styles.link_list_item} ${
                        asPath.split("?")[0] == coursesPageLink ||
                        coursesLevelPageLink
                          ? `${styles.active}`
                          : ""
                      }`}
                    >
                      Courses
                    </a>
                  </Link>
                </li>
              ) : (
                ""
              )}

              {query.course_slug && (
                <li>
                  <Link legacyBehavior href={`${coursesPageLink}`}>
                    <a
                      className={`${styles.link_list_item} ${
                        query.course_slug ? `${styles.active}` : ""
                      }`}
                    >
                      Course Details
                    </a>
                  </Link>
                </li>
              )}

              {asPath.includes("search-courses") && (
                <li className={`${styles.link_list_item} ${styles.active}`}>
                  Search Courses
                </li>
              )}

              {menuStatus?.sholarship && menuStatus?.sholarship == 1 ? (
                <li>
                  <Link legacyBehavior href={`${scholarshipsPageLink}`}>
                    <a
                      className={`${styles.link_list_item} ${
                        asPath === scholarshipsPageLink
                          ? `${styles.active}`
                          : ""
                      }`}
                    >
                      Scholarships
                    </a>
                  </Link>
                </li>
              ) : (
                ""
              )}

              {query.scholarship_slug && (
                <li className={`${styles.link_list_item} ${styles.active}`}>
                  Scholarship Details
                </li>
              )}

              {menuStatus?.blog && menuStatus?.blog == 1 ? (
                <li>
                  <Link legacyBehavior href={`${blogPageLink}`}>
                    <a
                      className={`${styles.link_list_item} ${
                        asPath === blogPageLink ? `${styles.active}` : ""
                      }`}
                    >
                      Blog
                    </a>
                  </Link>
                </li>
              ) : (
                ""
              )}

              {query.uni_blog_slug && (
                <li className={`${styles.link_list_item} ${styles.active}`}>
                  Blog Details
                </li>
              )}

              {menuStatus?.staff && menuStatus?.staff == 1 ? (
                <li>
                  <Link legacyBehavior href={`${staffPageLink}`}>
                    <a
                      className={`${styles.link_list_item} ${
                        asPath === staffPageLink ? `${styles.active}` : ""
                      }`}
                    >
                      Staff
                    </a>
                  </Link>
                </li>
              ) : (
                ""
              )}

              {query.staff_slug && (
                <li className={`${styles.link_list_item} ${styles.active}`}>
                  Staff Details
                </li>
              )}

              {menuStatus?.eventFair && menuStatus?.eventFair == 1 ? (
                <li>
                  <Link legacyBehavior href={`${eventFairPageLink}`}>
                    <a
                      className={`${styles.link_list_item} ${
                        asPath === eventFairPageLink ? `${styles.active}` : ""
                      }`}
                    >
                      Event/Fair
                    </a>
                  </Link>
                </li>
              ) : (
                ""
              )}

              {menuStatus?.gallery && menuStatus?.gallery == 1 ? (
                <li>
                  <Link legacyBehavior href={`${galleryPageLink}`}>
                    <a
                      className={`${styles.link_list_item} ${
                        asPath === galleryPageLink ? `${styles.active}` : ""
                      }`}
                    >
                      Gallery
                    </a>
                  </Link>
                </li>
              ) : (
                ""
              )}

              {query.slug && (
                <li className={`${styles.link_list_item} ${styles.active}`}>
                  Gallery Details
                </li>
              )}

              {menuStatus?.review && menuStatus?.review == 1 ? (
                <li>
                  <Link legacyBehavior href={`${reviewPageLink}`}>
                    <a
                      className={`${styles.link_list_item} ${
                        asPath === reviewPageLink ? `${styles.active}` : ""
                      }`}
                    >
                      Reviews
                    </a>
                  </Link>
                </li>
              ) : (
                ""
              )}

              <li>
                <Link legacyBehavior href={`${contactPageLink}`}>
                  <a
                    className={`${styles.link_list_item} ${
                      asPath === contactPageLink ? `${styles.active}` : ""
                    }`}
                  >
                    Contact
                  </a>
                </Link>
              </li>
              {query.course_slug && (
                <li>
                  <select
                    name="currencyCode"
                    id="currencyCode"
                    className={styles.currencyChanger}
                    onChange={setSystemCurrency}
                    disabled={systemInfo?.loading}
                    value={
                      systemInfo?.currency && systemInfo?.currency != ""
                        ? systemInfo?.currency
                        : props?.uniProfileData?.countryCurrency
                    }
                  >
                    {systemInfo?.loading ? (
                      <option value=""> Loading </option>
                    ) : (
                      <Fragment>
                        {systemInfo?.visitor_country?.currencies &&
                          systemInfo?.visitor_country?.currencies[0].toUpperCase() !=
                            props?.uniProfileData?.countryCurrency.toUpperCase() &&
                          systemInfo?.visitor_country?.currencies[0].toUpperCase() !=
                            "USD" && (
                            <option
                              value={systemInfo?.visitor_country?.currencies[0].toUpperCase()}
                            >
                              {systemInfo?.visitor_country?.currencies[0].toUpperCase()}
                            </option>
                          )}

                        {props?.uniProfileData?.countryCurrency &&
                          props?.uniProfileData?.countryCurrency != "USD" && (
                            <option
                              value={props?.uniProfileData?.countryCurrency}
                            >
                              {props?.uniProfileData?.countryCurrency}
                            </option>
                          )}

                        <option value="USD">USD</option>
                      </Fragment>
                    )}
                  </select>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniLinks;
